<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ teamType.id ? "Editar" : "Novo" }} Tipo de Equipe
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="teamType.name"
                        placeholder="Ex: UTI Móvel, Suporte Básico..."
                        maxlength="100"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Descrição:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="teamType.description"
                        placeholder=""
                        maxlength="255"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label>
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="teamType.status" class="form-control">
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/team_types" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('equipe.gerenciar')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teamType: {
        name: "",
        description: "",
        status: 1,
      },
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "team_types";

      self.teamType.node_id = self.$store.state.selected_node;

      if (self.teamType.id) {
        self.teamType._method = "PUT";
        api += "/" + self.teamType.id;
      }

      self.$loading(true);

      axios
        .post(api, self.teamType)
        .then(() => {
          self.$message("Sucesso", "Informações guardadas com sucesso", "success");
          self.$loading(false);
          self.$router.push("/team_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getTeamType: function (id) {
      const self = this;
      const api = self.$store.state.api + "team_types/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.teamType = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getTeamType(id);
    }
  },
};
</script>
